import { useContext, useEffect, useState } from "react";
import AppContext from "../../context";
import { readableColor } from "color2k";
import variables from "../../styles/export.module.scss";

const Settings = () => {
  const [showMeasurements, setShowMeasurements] = useState(true);
  const { showTooltips, handleSetShowTooltips } = useContext(AppContext);
  const handleSetShowHMeasurements = (checked) => {
    setShowMeasurements(checked);
    document.getElementById("vDimensionsSwitchCheckChecked").click();
    window?.hDimensionsSwitch?.();
  };
  const handleSetShowVMeasurements = (checked) => {
    window?.vDimensionsSwitch?.();
  };

  const labelStyle = {
    color: readableColor(variables.menuBgColor),
  };

  return (
    <div className="settings-container" id="settings">
      <div className="settings">
        <p className="settings--title title is-size-6" style={labelStyle}>
          Settings
        </p>
        {/*         <div
          className={`settings--switch ${
            bottomRequiredSwitchDisabled ? "is-disabled" : ""
          }`}
        >
          <span style={labelStyle}>Bottom Required</span>
          <label className="switch">
            <input
              type="checkbox"
              disabled={bottomRequiredSwitchDisabled}
              id="bottom-required"
              onChange={() => handleSetBottomRequired(!bottomRequired)}
              checked={bottomRequired}
            />
            <span className="slider round"></span>
          </label>
        </div> */}
        <div className="settings--switch">
          <span style={labelStyle}>Show Tooltips</span>
          <label className="switch">
            <input
              type="checkbox"
              onChange={(e) => handleSetShowTooltips(e.target.checked)}
              checked={showTooltips}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <div className="settings--switch">
          <span style={labelStyle}>Show Dimensions</span>
          <label className="switch">
            <input
              type="checkbox"
              id="hDimensionsSwitchCheckChecked"
              onChange={(e) => handleSetShowHMeasurements(e.target.checked)}
              checked={showMeasurements}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <div className="settings--switch">
          <span style={labelStyle}>View Drawer Box</span>
          <label className="switch">
            <input
              type="checkbox"
              id="viewDrawerBoxSwitch"
              onChange={(e) => window?.drawerBoxSwitch?.()}
              defaultChecked
            />
            <span className="slider round"></span>
          </label>
        </div>
        <div className="settings--switch is-hidden">
          <span>Show Vertical Measurements</span>
          <label className="switch">
            <input
              type="checkbox"
              id="vDimensionsSwitchCheckChecked"
              onChange={(e) => handleSetShowVMeasurements(e.target.checked)}
              checked={showMeasurements}
            />
            <span className="slider round"></span>
          </label>
        </div>
        {/*         <div className="settings--switch">
          <span>Enable Wireframe</span>
          <label className="switch">
            <input
              type="checkbox"
              id="flexSwitchCheckChecked"
              onClick={() => window?.wfSwitch?.()}
            />
            <span className="slider round"></span>
          </label>
        </div> */}
      </div>
      <hr className="horizontal"></hr>
    </div>
  );
};

export default Settings;
